<script>
import baseList from '@/views/components/base/baseList.vue'
import { Tag, Button } from 'view-design'
import Vue from 'vue'
export default {
  extends: baseList,
  components: {
  },
  data() {
    return {
      table: {
        mname: 'devicedamage',
        key: 'id',
        url: {
          list: '/maintainer/maintainer/damage/list'
        },
        output: false,
      },
      actions: [
        { label: '入库记录', type: 'warning', onClick: this.toretrieval, auth: '' },
        { label: '出库记录', type: 'warning', onClick: this.tocheckout, auth: '' },
        { label: '维修记录', type: 'warning', onClick: this.tomainten, auth: '' },
        { label: '损坏记录', type: 'warning', onClick: this.todamage, auth: '' },
        { label: '报废记录', type: 'warning', onClick: this.toscrap, auth: '' },
      ],

      filters: [

      ],
      tableCols: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: '资产名称',
          key: 'facilityName',
          minWidth: 100,
          align: 'left',
          render: (h, params) => {
            const row = params.row
            const text = row.facilityName
            return <span style={{ 'font-size': '14px' }}>{text}</span>
          },
        },
        {
          title: '损坏原因',
          key: 'cause',
          minWidth: 120,
          align: 'left',
        },
        {
          title: '填写人',
          key: 'writtenBy',
          minWidth: 120,
          align: 'left',
        },
        {
          title: '备注',
          minWidth: 180,
          align: 'left',
          key: 'remark',
        },
        {
          title: '更新时间',
          minWidth: 180,
          align: 'center',
          key: 'createTime',
        },
      ],
    }
  },
  created() {
       let query = this.$route.query
        if(query.facilityId) {
            this.query.facilityId = query.facilityId
            
        }
        this.facilityId=query.facilityId
    this.facilityNo=query.facilityNo
  },
  methods: {
    //入库记录
    toretrieval(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo
      $utils.url.push({
        name: "deviceRecordretrieval_list_weixiu",
        query: { facilityId: facilityId,facilityNo:facilityNo },
      });
    },
    //损坏记录
    todamage(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo
      $utils.url.push({
        name: "deviceRecorddamage_list_weixiu",
        query: { facilityId: facilityId,facilityNo:facilityNo },
      });
    },
    //出库记录
    tocheckout(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo
      $utils.url.push({
        name: "deviceRecordcheckout_list_weixiu",
        query: { facilityId: facilityId,facilityNo:facilityNo },
      });
    },
    //报废记录
    toscrap(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo
      $utils.url.push({
        name: "deviceRecordscrap_list_weixiu",
        query: { facilityId: facilityId,facilityNo:facilityNo },
      });
    },
    //维修记录
    tomainten(row = {}) {
      let facilityId = this.facilityId
      let facilityNo = this.facilityNo
      $utils.url.push({ name: 'deviceMaintenance_list_weixiu', query: { facilityId: facilityId,facilityNo:facilityNo  } })
    },
   
  },
}
</script>
<style scoped></style>
